import ctf from 'utils/contentfulService';
import _get from 'lodash/get';

const getTopicEvidence = async (_key, topicId, localeFilters) => {
  const response = await ctf.getEntries({
    content_type: 'evidence',
    'fields.topic.sys.id[in]': topicId,
    'fields.reviewStatus': 'Accepted',
    include: 2,
    ...localeFilters,
  });
  return _get(response, 'items', false);
};

export default getTopicEvidence;
